import { createRoutes } from 'shared/hocs'

import { SponsorsOverview } from './overview'
import { SponsorsAdd } from './overview/components/add'
import { SponsorsUpdate } from './overview/components/update'
import { MemberInvoicesOverview } from './overviewInvoices'
import { MemberInvoiceAdd } from './addMemberInvoice'
import { AddMemberBankAccount } from './addBankAccount'

export const Sponsors = createRoutes(({ match }) => [
  {
    path: `${match.path}/edit/:sponsorId`,
    component: SponsorsUpdate,
  },
  {
    exact: true,
    path: `${match.path}/add`,
    component: SponsorsAdd,
  },
  {
    path: `${match.path}/bank-account/:memberId`,
    component: AddMemberBankAccount,
  },
  {
    exact: true,
    path: `${match.path}/invoices/:memberId`,
    component: MemberInvoicesOverview,
  },
  {
    exact: true,
    path: `${match.path}/add-invoices/:memberId`,
    component: MemberInvoiceAdd,
  },
  {
    exact: true,
    path: match.path,
    component: SponsorsOverview,
  },
])
